// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iqpI","top":"styles_top__3fsc5"};